import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [MatProgressSpinner],
})
export class SpinnerComponent {
  @Input() spinnerSize: number = 44;
}
